module.exports = __webpack_public_path__ + "static/assets/eb669e1cb0f2289acee39dc49b2c25a5.png";